import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateRealestateNetYearlyIncome } from "./netYearlyIncome";
import { calculateRentYearly } from "./rent";

export const calculateRealestateDestinationStateCurrency = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const destinationStateTax = userProduct?.destinationStateFee || 0;
  const destinationStateType = userProduct?.destinationStateFeeFromRevenue;

  const netYearlyIncome = calculateRealestateNetYearlyIncome(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  const totalIncome = calculateRentYearly(userProduct);

  return destinationStateType
    ? (totalIncome * destinationStateTax) / 100
    : (netYearlyIncome * destinationStateTax) / 100;
};
